import apiHeader from '@/helpers/apiHeader';

const requestListService = {
    list(params) {
        return apiHeader.post('request-pool/request-list', params);
    },
    detail(id) {
        return apiHeader.get(`request-pool/request-list/${id}`);
    },
    detailWithoutSubRelations(id) {
        return apiHeader.get(`request-pool/request-list/simple/${id}`);
    },
    detailEmcrItem(params) {
        return apiHeader.get(`request-pool/request-list/emcr-item`, { params });
    },
    detailChangeMatForApprCat(id) {
        return apiHeader.get(`request-pool/request-list/get-for-eu-material-apprv-cat/${id}`);
    },
    checkLock(mcrItemCode) {
        return apiHeader.get(`request-pool/request-list/check-lock/${mcrItemCode}`);
    },
    lockItem(mcrItemCode) {
        return apiHeader.get(`request-pool/request-list/lock-item/${mcrItemCode}`);
    },
    unlockItem(mcrItemCode) {
        return apiHeader.get(`request-pool/request-list/unlock-item/${mcrItemCode}`);
    },
    checkCurrentApprovalStep(mcr_code) {
        return apiHeader.get(`request-pool/request-list/check-approval/${mcr_code}`);
    }
};

export default requestListService;